interface HeroData {
  name: string;
  image: string;
  onClick: () => void;
}

interface HeroSectionProps {
  heroes: HeroData[];
}

export const HeroSection = ({ heroes }: HeroSectionProps) => {
  const heroCount = heroes.length;
  
  return (
    <div className={`hero-images-container hero-count-${heroCount}`}>
      {heroes.map((hero, index) => (
        <div key={index} className="hero-item">
          <div 
            onClick={hero.onClick}
            className="hero-clickable"
          >
            <img 
              src={hero.image} 
              alt={`Vista de ${hero.name}`}
              className="municipality-image"
            />
          </div>
          <h1 className="municipality-name">{hero.name}</h1>
        </div>
      ))}
    </div>
  );
};
